import { Link } from '@/i18n/routing';
import { IconType } from 'react-icons';

type IconButtonProps = {
  Icon: IconType;
  onClick?: () => void;
  link?: string;
};

const IconButton = ({ Icon, onClick, link }: IconButtonProps) => {
  return (
    <div className="flex items-center">
      {link ? (
        <Link href={link}>
          <Icon className="text-2xl text-black dark:text-white" />
        </Link>
      ) : (
        <button
          onClick={onClick}
          className="transition-transform duration-300 ease-in-out focus:outline-none focus:ring-0"
        >
          <Icon className="text-2xl text-black dark:text-white" />
        </button>
      )}
    </div>
  );
};

export default IconButton;
